var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player"},[_c('i',{staticClass:"el-icon-close",class:{ isMobile: (_vm.deviceWidth <= 1074) },on:{"click":_vm.closeVideo}}),_c('video',{ref:"videoPlayer",attrs:{"autoplay":"","src":_vm.videoSrc,"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }